import React, { useCallback, useState } from 'react';

import { IconButton } from '@mui/material';

import HelpIcon from 'assets/icons/icn _ 24px _ help.svg?react';

import TMXTooltip from './TMXTooltip';

const HelpTooltip = (props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

  const handleTooltipClose = useCallback(() => {
    setIsTooltipOpen(false);
  }, [setIsTooltipOpen]);

  const handleTooltipOpen = useCallback(() => {
    setIsTooltipOpen(true);
  }, [setIsTooltipOpen]);

  return (
    <TMXTooltip open={isTooltipOpen} onClose={handleTooltipClose} {...props}>
      <IconButton disableFocusRipple disableRipple size="small" onClick={handleTooltipOpen}>
        <HelpIcon height={22} width={22} />
      </IconButton>
    </TMXTooltip>
  );
};

export default HelpTooltip;
